// returns true when url is pointing to another domain
export default function (url) {
  if (!url) return false
  if (!url.indexOf) return false
  if (url.indexOf('http') !== 0) return false

  return url.indexOf(window.location.protocol + '//' + window.location.hostname) !== 0
}
